module.exports = __webpack_public_path__ + "img/1.b15d71ac.jpg";